{/*let token = process.env.NEXT_PUBLIC_BEARER_TOKEN;
if (typeof window !== "undefined" && !token) {
  const authData = localStorage.getItem("auth");

  if (authData) {
    token = `${JSON.parse(authData).data.accessToken}`;
  }
}

export const config = {
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || "https://automation-qa.unilever.com/api",
  bearerToken:
    process.env.NEXT_PUBLIC_BEARER_TOKEN ||
    token
};

let token;
let tokenWithoutBearer;
if (typeof window !== "undefined" && !token) {
 let auth = JSON.parse(localStorage.getItem("auth"));

  if (auth && auth.data) { 
    tokenWithoutBearer = `${auth.data.accessToken}`;
    token = tokenWithoutBearer.replace('Bearer ', '');
  }
}
export const config = {
  baseUrl: "https://automation-qa.unilever.com/api",
  bearerToken:    
    token
};
*/}
// config.js

let token;
let tokenWithoutBearer;

function initializeToken() {
  if (typeof window !== "undefined" && !token) {
    let auth = JSON.parse(localStorage.getItem("auth"));

    if (auth && auth?.data) {
      tokenWithoutBearer = `${auth.data.accessToken}`;
      token = tokenWithoutBearer.replace('Bearer ', '');
    }
  }
}

// Call initializeToken to populate the token
initializeToken();

export const config = {
  baseUrl: process.env.NEXT_PUBLIC_BASE_URL || "https://automation.unilever.com/api",
  get bearerToken() {
    // Call initializeToken to ensure token is up-to-date
    initializeToken();
    return process.env.NEXT_PUBLIC_BEARER_TOKEN || token;
  }
};

